export default "__VITE_ASSET__BIxsnDyH__"